import { Location } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MenuController, Platform } from '@ionic/angular';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
})
export class HeaderComponent implements OnInit {
  @Output() viewProfile = new EventEmitter<void>();
  @Input() label: string;
  @Input() showBack: boolean = true;
  @Input() showSearch: boolean = true;
  @Input() showSetting: boolean = true;
  @Input() showMenu: boolean = false;
  @Input() saveButton: string;
  @Input() showProfile: boolean = true;

  @Output() saveClick = new EventEmitter<string>();
  constructor(public platform: Platform, public menuCtrl: MenuController, public location: Location) { }

  ngOnInit() { }

  clicked() {
    this.saveClick.emit();
  }


}
